import {
  decryptEncryptedJWT,
  getCookie,
  localStorageMethod
} from 'src/common/config/FunctionHelper';
import {
  tagManagerEvent,
  tagManagerPurchaseEvent,
  tagManagerEventWithSource,
  tagManagerLoginEvent
} from './TagManagerEventHelper';

/**
 * This function is used to track when a new user signs up.
 *
 * @param {payload} email - The user's email address.
 */
export const signUpTrackEvent = (payload: any) => {
  let localIsFreeAudit = localStorageMethod('get', 'isFreeAudit');
  if (localIsFreeAudit == 'true') {
    tagManagerEvent('create-account-free-audit', payload.email);
  } else {
    let sourceDetails;
    if (localIsFreeAudit == 'true') {
      sourceDetails = 'pricing page';
    } else if (payload?.sourceDetail) {
      sourceDetails = 'free seo audit page';
    } else if (localIsFreeAudit == undefined && !payload?.sourceDetail) {
      sourceDetails = 'signup page';
    }
    let sourceData = { email: payload?.email, signup_source: sourceDetails };
    tagManagerEventWithSource('create-account', sourceData);
  }
  localStorageMethod('remove', 'isFreeAudit');
};

/**
 * This function is used to track when a user installs the plugin.
 */
export const pluginInstallTrackEvent = async () => {
  const encodedJWT = getCookie(process.env.REACT_APP_COOKIE_NAME);

  const jwtDecode: any = await decryptEncryptedJWT(encodedJWT);
  if (jwtDecode) {
    tagManagerEvent('download-plugin-click', jwtDecode?.email);
  }
};

/**
 * This function is used to track when a user selects a free trial.
 *
 * @param {string} email - The user's email address.
 */
export const selectTrialTrackEvent = (email: string) => {
  tagManagerEvent('free-plan-click', email);
};

/**
 * This function is used to track when a user selects a free trial plan.
 *
 * @param {string} email - The user's email address.
 */
export const selectTrialPlanTrackEvent = (email: string, planName: string) => {
  let sanitizePlanName =
    planName?.charAt(0)?.toUpperCase() + planName?.slice(1)?.toLowerCase();
  tagManagerEvent('free-trial-click-' + sanitizePlanName, email);
};

/**
 * This function is used to track when a user completes a payment.
 *
 * @param {string} email - The user's email address.
 */
export const paymentTrackEvent = (email: string, ecommerce: any) => {
  tagManagerEvent('payment-successful', email);
  if (ecommerce && ecommerce.items) {
    ecommerce.items[0].plan_option = ecommerce?.items[0]?.item_category;
  }
  tagManagerPurchaseEvent('purchase', ecommerce);
};

/**
 * This function is used to track when a user completes a payment.
 *
 * @param {string} email - The user's email address.
 */
export const auditCompleteTrackEvent = (site: string) => {
  tagManagerEvent('site-audit-complete', site);
};

export const beginCheckoutTrackEvent = (planName, payload: any) => {
  let sanitizePlanName =
    planName?.charAt(0)?.toUpperCase() + planName?.slice(1)?.toLowerCase();
  tagManagerPurchaseEvent('begin-checkout-' + sanitizePlanName, payload);
};

export const loginGTMTrackEvent = (autoLogin: Boolean) => {
  tagManagerLoginEvent('login', autoLogin);
};
